import React from 'react';
import { TextField, useFieldHelper, FieldProps } from 'framework/ui/field';

interface FTEFieldProps extends FieldProps {
  fteSource: string;
}

const FTEField = ({ fteSource, ...props }: FTEFieldProps) => {
  const { getValue: getFte } = useFieldHelper<number>({ source: fteSource });

  const getFTEValue = () => {
    const fteValue = getFte();

    if (fteValue && fteValue > 0) {
      return fteValue.toFixed(2);
    }

    return 0;
  };

  const displayValue = getFTEValue();

  return <TextField {...props} value={`${displayValue} FTE`} label="" />;
};

export default FTEField;
